import { useLocation } from 'react-router-dom'
import {
  ROUTE_HOME,
  ROUTE_TRANSACTIONS_ALL_TRANSACTIONS,
  ROUTE_TRANSACTIONS_STATEMENTS,
} from '@/routes/paths'
import { StaticAnnouncement } from '@/components/static-announcement'
import { Icons } from '@/theme/Images'

const isDiscontinuedBannerEnabled = () => import.meta.env.VITE_ENABLE_DISCONTINUED_BANNER === 'true'

function getBannerClass(pathname) {
  const base = 'bg-bgGray md:mx-[10%] my-6 md:mt-[2%]'
  return [ROUTE_HOME, ROUTE_TRANSACTIONS_ALL_TRANSACTIONS, ROUTE_TRANSACTIONS_STATEMENTS].includes(pathname)
    ? `${base} md:m-0 mx-0`
    : `${base} md:m-0 mx-6`
}

const BANNER_TEXT = (
    <>
      <span className="font-semibold">NOTICE: </span>
      All Fasten accounts are now closed to new transactions. Access to the Fasten Web App is ending on May 31, 2026.
      If you wish to make any final payments from your linked bank account, please do so before this date.
      Payments after this date must be made by check to ensure your account remains in good standing.
      Delinquent accounts may be sent to collections. &nbsp;
      <a className="font-semibold text-brand-500" href="https://fastenrewards.zendesk.com/hc/en-us/articles/49693816651027-Where-should-I-send-my-payments">
        More information can be found in our FAQ.
      </a>
    </>
)

const FastenDiscontinuedBanner = () => {
  const {pathname} = useLocation()
  const pathSegment = pathname?.split('/').at(-1) ?? ''
  const bannerClass = getBannerClass(pathSegment)

  if (!isDiscontinuedBannerEnabled()) {
    return null
  }

  return (
    <div className={bannerClass}>
      <div className="flex flex-col md:gap-8 gap-5">
        <StaticAnnouncement
          noShadow
          startIcon={Icons.grayNotificationIcon}
          text={BANNER_TEXT}
        />
      </div>
    </div>
  )
}

export default FastenDiscontinuedBanner
